import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { AddIcon } from "../../images/Icons"
import { associatePartyEvent } from '../currentPartyEvent/currentPartyEventSlice'
import { selectPartyEventsCount } from './partyEventsSlice'
import '../../App.css'
import { isDate } from 'util/types'
import { dateToTransmissionDateTime } from '../../utils/dateUtils'

export function AddPartyEventButton() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const partyEventsCount = useAppSelector(selectPartyEventsCount)
    return (
        <div className='iconButton' onClick={() => {
            dispatch(associatePartyEvent({
                id: 0 - partyEventsCount,
                title: '',
                location: '',
                reference: '',
                start: dateToTransmissionDateTime( new Date()),
                end: dateToTransmissionDateTime(new Date()),
                userOkToDelete: true
            }))
            navigate('/Welcome')
        }}>
            <AddIcon />
        </div>
    )
}